<template>
  <div class="flex space-x-2" data-intercom-target="TemplateGalleryNav">
    <button
      v-for="(tab, index) in tabs"
      :key="tab.key?.toString() ?? index"
      :class="[
        {
          'bg-primary-99 text-primary-60': tab.key === selected?.key,
        },
        'rounded-md px-3 py-2 text-sm font-normal text-neutral-0 outline-none hover:bg-primary-99 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-70 focus-visible:ring-offset-1 focus-visible:ring-offset-primary-60',
      ]"
      :data-intercom-target="tab.content?.dataIntercomTarget"
      @click="updateSelected(tab)"
    >
      {{ tab.value }}
    </button>
  </div>
</template>

<script lang="ts" setup generic="ItemKey">
import type { Items, Item } from "./buttonTabs.types";

withDefaults(
  defineProps<{
    tabs: Items<ItemKey>;
    selected?: Item<ItemKey>;
  }>(),
  {},
);

const emit = defineEmits<{
  "update:selected": [tab: Item<ItemKey>];
}>();

const updateSelected = (newTab: Item<ItemKey>) => {
  emit("update:selected", newTab);
};
</script>
